import React from "react";

export type OpTab = "configurations" | "catalogue" | "assumptions";

const TABS: { id: OpTab; label: string }[] = [
  { id: "configurations", label: "Configurations" },
  { id: "catalogue", label: "Catalogue" },
  { id: "assumptions", label: "Assumptions" },
];

interface OpTabNavProps {
  activeTab: OpTab;
  onChange: (tab: OpTab) => void;
}

const OpTabNav = ({ activeTab, onChange }: OpTabNavProps) => (
  <nav className="tab-nav" role="tablist" aria-label="On-Pipe configurator sections">
    <div className="tab-nav__inner">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`tab-button${activeTab === tab.id ? " tab-button--active" : ""}`}
          role="tab"
          aria-selected={activeTab === tab.id}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  </nav>
);

export default OpTabNav;
